import React from "react";

const CaliforniaNotice = () => {
  return (
    <div className="legal-section">
      <h2>California Privacy Notice</h2>
      <p>Last updated: March 19, 2024</p>

      <h3>1. Introduction</h3>
      <p>
        This notice provides information for California residents about data
        handling practices on our platform. Our service utilizes Google
        Firebase, which maintains compliance with California privacy laws.
      </p>

      <h3>2. Infrastructure Information</h3>
      <p>Our platform is built on Firebase, which provides:</p>
      <ul>
        <li>Secure data storage and processing capabilities</li>
        <li>Industry-standard security measures</li>
        <li>Tools for managing user privacy preferences</li>
      </ul>

      <h3>3. California Privacy Rights</h3>
      <p>
        California residents may have certain rights regarding their personal
        information:
      </p>
      <ul>
        <li>Right to know about personal information collected</li>
        <li>Right to request deletion of personal information</li>
        <li>Right to access personal information</li>
        <li>Right to non-discrimination for exercising these rights</li>
      </ul>

      <h3>4. Data Processing</h3>
      <p>Through our Firebase-based platform, we:</p>
      <ul>
        <li>Collect and store necessary user data</li>
        <li>Process data for platform functionality</li>
        <li>Implement security measures provided by Firebase</li>
        <li>Do not sell personal information</li>
      </ul>

      <h3>5. Exercising Your Rights</h3>
      <p>To exercise your California privacy rights:</p>
      <ul>
        <li>Email: info@socrateslab.com</li>
        <li>Use the privacy controls in your account settings</li>
        <li>Contact our support team through the platform</li>
      </ul>

      <h3>6. Response Process</h3>
      <p>
        We will acknowledge receipt of your request and provide information
        about how we will process it. Response times and capabilities may vary
        based on technical and operational factors.
      </p>
    </div>
  );
};

export default CaliforniaNotice;
